import styled from 'styled-components/native';

import { Text } from 'app/components/Common/Styled';

export const DisclaimerText = styled(Text).attrs({
  size: 'small',
})``;
